import React, {PureComponent} from 'react';
import $ from "jquery";
import {formatDate} from "../functions/utils";
import parallel from "async/parallel";
import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class Code60Monitor extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            speedLimit: -1,
            sessionDetails: {
                session_status: -1,
            }
        };

        this.handleSpeedChange = this.handleSpeedChange.bind(this);
        this.handleUpdateValue = this.handleUpdateValue.bind(this);
        this.getIssueData = this.getIssueData.bind(this);
        this.popoutTelemetry = this.popoutTelemetry.bind(this);
        this.makeRows = this.makeRows.bind(this);
        this.getSessionDetails = this.getSessionDetails.bind(this);
    }

    componentDidMount() {
        const helper = this;
        parallel([
            function (callback) {
                helper.getIssueData((status) => {
                    callback(null, status);
                });
            },
            function (callback) {
                helper.getSessionDetails((status) => {
                    callback(null, status);
                });
            }
        ], function (err, result) {
            helper.makeRows(helper.state.data);
        });
    }

    // GET DATA
    getIssueData(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionIssueList',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                eventID: parseInt(helper.props.match.params.eventID),
                sessionID: parseInt(helper.props.match.params.sessionID),
                issueID: parseInt(helper.props.match.params.issueID),
            },
            success: function (data) {
                helper.setState({
                    data: data,
                    speedLimit: data[1][0].speed_threshold_flag,
                    calculatedSpeedLimit: data[0][0].current_regulamentar_speed_limit,
                    timezone: data[1][0].timezone,
                }, () => {
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                $(".loading").fadeOut();
                callback("nok");
            }
        });
    }

    getSessionDetails(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    sessionDetails: data,
                }, () => {
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    // HANDLERS
    handleSpeedChange(e) {
        e.preventDefault();
        this.setState({
            speedLimit: parseInt(e.target.value),
        });
    }

    handleUpdateValue() {
        $(".loading").fadeIn();
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/updateSpeedThreshold',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                eventID: parseInt(helper.props.match.params.eventID),
                newValue: helper.state.speedLimit,
            },
            success: function (data) {
                helper.makeRows(helper.state.data);
            },
            error: function (err) {
                if (err) {
                    console.error('Error Updating speed limit:', err);
                }
                return false;
            }
        });
    }

    makeRows(data) {
        let rows = [];

        let penaltyStyle = {
            fontWeight: "bold",
            fontSize: 25,
            color: "#ff1719"
        };

        for (let i = 0; i < data[0].length; i++) {

            let clear_date = data[0][i].sched_end_timestamp === null ? data[0][i].flag_clear_date : data[0][i].sched_end_timestamp;
            let display_date = data[0][i].sched_display_timestamp === null ? data[0][i].display_date : data[0][i].sched_display_timestamp;

            let speedSource = data[0][i].speed_source;
            let issueTotalTime = (clear_date - display_date) / 1000;
            let timeOverGPS = data[0][i].time_above_regulamentar_gps_speed_limit;
            let timeOverOBD = data[0][i].time_above_regulamentar_obd_speed_limit;
            let percent = (speedSource === "OBD" ? (timeOverOBD / issueTotalTime) * 100 : (timeOverGPS / issueTotalTime) * 100);
            let speedToShow = data[0][i].speed_source === "OBD" ? data[0][i].max_obd_speed : data[0][i].max_gps_speed;

            rows.push(
                <tr key={"car_" + data[0][i].livery_number} className={"onHover App_white_text w3-animate-fading"} style={{textAlign: "center", fontSize: 22}}>
                    <td>
                        <button
                            style={{background: "#ff0003", fontWeight: "bold"}}
                            type={"button"}
                            className={"btn printWhite button"}
                            value={data[0][i].car_id + "_" + display_date + "_" + clear_date}
                            onClick={this.popoutTelemetry}
                        >
                            <i className={"fas fa-search"} style={{color: "#FFFFFF"}}/>
                        </button>
                    </td>
                    <td className={"App_bold_text"}>#{data[0][i].livery_number}</td>
                    <td className={"text-left"}>{data[0][i].team_name}</td>
                    <td style={speedToShow > this.state.speedLimit ? penaltyStyle : {}}>{speedToShow} km/h</td>
                    <td>{formatDate(data[0][i].flag_issue_date, this.state.timezone)}</td>
                    <td>{formatDate(display_date, this.state.timezone)}</td>
                    <td>{formatDate(clear_date, this.state.timezone)}</td>
                    <td>{Math.round(percent)} %</td>
                </tr>
            );
        }

        this.setState({
            rows: rows,
        }, () => {
            $(".loading").fadeOut();
        });
    }

    // POPOUT
    popoutTelemetry(e) {
        e.preventDefault();
        let parts = e.currentTarget.value.split("_");
        window.open(
            "/flagIssueDetails/" +
            this.props.match.params.eventID + "/" +
            this.props.match.params.sessionID + "/" +
            parts[0] + "/" +
            parts[1] + "/" +
            parts[2] + "/" +
            this.props.match.params.userID + "/" +
            this.state.sessionDetails.map_center_lat + "/" +
            this.state.sessionDetails.map_center_lng + "/" +
            this.state.sessionDetails.map_center_zoom_level + "/" +
            this.state.sessionDetails.map_rotation + "/" +
            this.props.match.params.issueID + "/" +
            this.state.calculatedSpeedLimit,
            'flagIssueDetails',
            "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no, width=0,height=0,left=20,top=100,width=800,height=850",
        );
    }

    render() {
        return (
            <>
                <div className="loading">
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                {this.state.sessionDetails.session_status <= 2 ? (
                    <div className={"row row-flex App_categoryHeader w3-animate-fading"} style={{padding: 10}}>
                        <div className={"col-xs-12"}>
                            <label className={"App_title"}>{this.props.t("speedThreshold")} (km/h)</label>
                        </div>
                        <div className={"col-xs-6 col-md-1"}>
                            <input
                                type={"number"}
                                style={{borderColor: "#ea1f24", borderWidth: "medium"}}
                                className={"form-control App_black_text"}
                                value={this.state.speedLimit}
                                placeholder={this.props.t("enterValue")}
                                onChange={this.handleSpeedChange}
                            />
                        </div>
                        <div className={"col-xs-6 col-md-2"}>
                            <button
                                style={{background: "#ff0003", fontWeight: "bold", padding: 5, fontSize: 15}}
                                type={"button"}
                                className={"btn App_white_text_liveMaxes button"}
                                onClick={this.handleUpdateValue}
                            >
                                {this.props.t("updateLimit").toUpperCase()}
                            </button>
                        </div>
                    </div>
                ) : null}
                <div className={"table-responsive table-scroll-parent App_lapTableContainerStyle w3-animate-fading"} style={{height: "86vh"}}>
                    <div className={"table-scroll-child"}>
                        <table className={"table table-hover"}>
                            <thead>
                            <tr>
                                <th className={"App_header"} colSpan={4}/>
                                <th className={"App_header"} colSpan={3} style={{whiteSpace: "nowrap", borderLeft: "2px solid white"}}>{this.props.t("timestamps").toUpperCase()}</th>
                                <th className={"App_header"} rowSpan={2} style={{borderLeft: "2px solid white"}}>{this.props.t("timeAboveLimit").toUpperCase()} ({this.props.t("limit") + ": " + this.state.calculatedSpeedLimit} km/h)</th>
                            </tr>
                            <tr style={{whiteSpace: "nowrap"}}>
                                <th/>
                                <th id={"nr"} className={"App_header"}>{this.props.t("nr")}</th>
                                <th className={"App_header"} style={{textAlign: "left", width: "15%"}}>{this.props.t("team")}</th>
                                <th id={"state"} className={"App_header"} onClick={this.handleChangeSort}>{this.props.t("maxSpd")}</th>
                                <th id={"numPits"} className={"App_header"} style={{borderLeft: "2px solid white"}}>{this.props.t("issue").toUpperCase()}</th>
                                <th id={"fastestPit"} className={"App_header"}>{this.props.t("display").toUpperCase()}</th>
                                <th id={"totalPitTime"} className={"App_header"} style={{borderRight: "2px solid white"}}>{this.props.t("clear").toUpperCase()}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.rows}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(Code60Monitor));